/**
 *
 * WorldRecordDetails
 *
 */

import React, { memo, FunctionComponent, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import messages from './messages';
import {
  ComponentDialogBody,
  StyledDialogActionsBar,
  StyledModalAction,
} from '../../../../components/DiaogWrap/styles';
import { Column, Row, Wrap } from '../../../../assets/styledAssets/grid';
import {
  StyledDropDownList,
  StyledFormField,
  StyledLabel,
} from '../../../../components/FormField/styles';
import { Input } from '@progress/kendo-react-inputs';
import {
  WorldEvent,
  WorldRank,
  WorldRecord,
  WorldRecordType,
} from '../../worldrecords';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
import {
  convertFromTimeMaskToSec,
  convertToTimeMask,
} from '../../../../helpers/app.helpers';
import AchievementsService from '../../../../service/Achievements.service';
import { filterBy } from '@progress/kendo-data-query';

interface IProps {
  onCancel: () => void;
  onSave: (record: WorldRecord) => void;
  worldRecord?: WorldRecord;
}

const rankValue = [
  { id: WorldRank.Recreation, name: 'Recreation' },
  { id: WorldRank.Junior, name: 'Junior' },
  { id: WorldRank.Regional, name: 'Regional' },
  { id: WorldRank.National, name: 'National' },
  { id: WorldRank.International, name: 'International' },
];

const WorldRecordDetails: FunctionComponent<IProps> = ({
  worldRecord,
  onCancel,
  onSave,
}) => {
  const intl = useIntl();
  const [record, setRecord] = useState<Partial<WorldRecord> | undefined>(
    worldRecord,
  );
  const [listEvents, setListEvents] = useState<WorldEvent[]>([]);
  const [fListEvents, setFListEvents] = useState<WorldEvent[]>([]);

  useEffect(() => {
    AchievementsService.fetchEvents().then((res) => {
      res.items = res.items.filter(
        (item) => item.input !== WorldRecordType.Rank,
      );
      setListEvents(res.items);
      setFListEvents(res.items);
    });
  }, []);

  useEffect(() => {
    if (record?.event?.input === WorldRecordType.Rank) {
      setRecord({
        ...record,
        men: WorldRank.International,
        women: WorldRank.International,
      });
    } else if (!record?.id) {
      setRecord({
        ...record,
        men: 0,
        women: 0,
      });
    }
    // eslint-disable-next-line
  }, [record?.eventId]);

  const itemFromValue = (list: any[], value: any) => {
    return list.find((item) => item.id === value);
  };

  const filterData = (filter: any) => {
    const data = listEvents.slice();
    return filterBy(data, filter);
  };

  const filterChange = (event: any) => {
    setFListEvents(filterData(event.filter));
  };

  return (
    <>
      <ComponentDialogBody>
        <Row>
          <Wrap margin={'0 0 3rem'} width={'100%'}>
            <Column xs={100} md={100} padding={'1.5rem'}>
              <StyledLabel>{intl.formatMessage(messages.name)}</StyledLabel>
              <StyledDropDownList
                data={fListEvents}
                textField={'name'}
                dataItemKey={'id'}
                value={itemFromValue(listEvents, record?.event?.id)}
                filterable={true}
                onFilterChange={filterChange}
                disabled={!!record?.id}
                onChange={(e) =>
                  setRecord({
                    ...record,
                    event: e.value as WorldEvent,
                    eventId: e.value.id,
                  })
                }
              />
            </Column>
            {/*            <Column xs={100} md={100} padding={'1.5rem'}>
              <StyledLabel>
                {intl.formatMessage(messages.recordType)}
              </StyledLabel>
              <StyledDropDownList
                data={recordTypes}
                textField={'name'}
                dataItemKey={'id'}
                value={itemFromValue(recordTypes, record?.event?.input)}
                onChange={(e) =>
                  setRecord({
                    ...record,
                    event: {
                      ...record?.event,
                      input: e.value.id,
                    } as WorldEvent,
                  })
                }
              />
            </Column>*/}
            {record?.event?.input === WorldRecordType.Rank && (
              <Column xs={100} md={100} padding={'1.5rem'}>
                <StyledLabel>
                  {intl.formatMessage(messages.maleValue)}
                </StyledLabel>
                <StyledDropDownList
                  data={rankValue}
                  textField={'name'}
                  dataItemKey={'id'}
                  disabled
                  value={itemFromValue(rankValue, record?.men)}
                  onChange={(e) => setRecord({ ...record, men: e.value })}
                />
              </Column>
            )}
            {record?.event?.input === WorldRecordType.Time && (
              <Column xs={100} md={100} padding={'1.5rem'}>
                <StyledLabel>
                  {intl.formatMessage(messages.maleValue)}
                </StyledLabel>
                <StyledFormField>
                  <MaskedTextBox
                    mask="00:00:00.00"
                    onChange={(e) =>
                      setRecord({
                        ...record,
                        men: convertFromTimeMaskToSec(e.target.value),
                      })
                    }
                    value={convertToTimeMask(record?.men || 0)}
                  />
                </StyledFormField>
              </Column>
            )}
            {![WorldRecordType.Rank, WorldRecordType.Time].includes(
              record?.event?.input as WorldRecordType,
            ) && (
              <Column xs={100} md={100} padding={'1.5rem'}>
                <StyledLabel>
                  {intl.formatMessage(messages.maleValue)}
                </StyledLabel>
                <StyledFormField>
                  <Input
                    type={'number'}
                    onChange={(e) =>
                      setRecord({ ...record, men: parseFloat(e.value) })
                    }
                    value={record?.men}
                  />
                </StyledFormField>
              </Column>
            )}
            {record?.event?.input === WorldRecordType.Rank && (
              <Column xs={100} md={100} padding={'1.5rem'}>
                <StyledLabel>
                  {intl.formatMessage(messages.femaleValue)}
                </StyledLabel>
                <StyledDropDownList
                  data={rankValue}
                  textField={'name'}
                  dataItemKey={'id'}
                  disabled
                  value={itemFromValue(rankValue, record?.women)}
                  onChange={(e) => setRecord({ ...record, women: e.value })}
                />
              </Column>
            )}
            {record?.event?.input === WorldRecordType.Time && (
              <Column xs={100} md={100} padding={'1.5rem'}>
                <StyledLabel>
                  {intl.formatMessage(messages.femaleValue)}
                </StyledLabel>
                <StyledFormField>
                  <MaskedTextBox
                    mask="00:00:00.00"
                    onChange={(e) =>
                      setRecord({
                        ...record,
                        women: convertFromTimeMaskToSec(e.target.value),
                      })
                    }
                    value={convertToTimeMask(record?.women || 0)}
                  />
                </StyledFormField>
              </Column>
            )}
            {![WorldRecordType.Rank, WorldRecordType.Time].includes(
              record?.event?.input as WorldRecordType,
            ) && (
              <Column xs={100} md={100} padding={'1.5rem'}>
                <StyledLabel>
                  {intl.formatMessage(messages.femaleValue)}
                </StyledLabel>
                <StyledFormField>
                  <Input
                    type={'number'}
                    onChange={(e) =>
                      setRecord({ ...record, women: parseFloat(e.value) })
                    }
                    value={record?.women}
                  />
                </StyledFormField>
              </Column>
            )}
          </Wrap>
        </Row>
      </ComponentDialogBody>
      <StyledDialogActionsBar>
        <StyledModalAction onClick={onCancel}>
          {intl.formatMessage(messages.cancel)}
        </StyledModalAction>
        <StyledModalAction accent onClick={() => onSave(record as WorldRecord)}>
          {intl.formatMessage(messages.save)}
        </StyledModalAction>
      </StyledDialogActionsBar>
    </>
  );
};

export default memo(WorldRecordDetails);
